import { Box, Skeleton, useTheme } from "@mui/material"

export const SkeletonStepByStepSidebar = () => {
  const theme = useTheme()
  const {
    root,
    stepContainer,
    stepItem,
    locationAvatar,
    locationText,
    stepProgressBarContainer,
    stepProgressBar,
    actionContainer,
    button,
  } = theme.components[`SkeletonStepByStepSidebar`]?.styleOverrides || {}

  return (
    <Box sx={root}>
      <Box sx={stepContainer}>
        <Box sx={stepItem}>
          <Skeleton sx={locationAvatar} variant="rounded" />
          <Skeleton sx={locationText} variant="text" />
        </Box>
        <Box sx={stepProgressBarContainer}>
          <Skeleton sx={stepProgressBar} variant="rounded" />
        </Box>
        <Box sx={stepItem}>
          <Skeleton sx={locationAvatar} variant="rounded" />
        </Box>
      </Box>
      <Box sx={actionContainer}>
        <Skeleton sx={button} variant="rounded" />
        <Skeleton sx={button} variant="rounded" />
      </Box>
    </Box>
  )
}
